import { createContext, useContext } from 'react';

/**
 * TOBB UZENET KIJELOLESE tovabbitashoz (versenyaudit U5).
 *
 * A csatorna nezete adja (ChannelView); az uzenetsorok ebbol tudjak, hogy
 * kijelolo modban vagyunk-e, es ki van-e jelolve az adott uzenet. Kijelolo
 * modban az egesz sor kattintasra jelol - linkre, gombra sem nyit semmit.
 */
export const MAX_FORWARD_MESSAGES = 5;

export interface MessageSelection {
  active: boolean;
  selected: string[];
  toggle: (messageId: string) => void;
}

const inactive: MessageSelection = { active: false, selected: [], toggle: () => undefined };

export const MessageSelectionContext = createContext<MessageSelection>(inactive);

export function useMessageSelection(): MessageSelection {
  return useContext(MessageSelectionContext);
}
